import { createAuthClient } from 'better-auth/react'
import { inferAdditionalFields } from 'better-auth/client/plugins'
import { API_ROUTES } from '@brochure/shared'

// Stesso origin del sito (proxy Vite in dev, nginx in produzione): endpoint sotto /api/auth.
// I campi aggiuntivi rispecchiano `user.additionalFields` in apps/backend/src/auth.ts.
export const authClient = createAuthClient({
  basePath: API_ROUTES.auth,
  plugins: [
    inferAdditionalFields({
      user: {
        firstName: { type: 'string', required: false },
        lastName: { type: 'string', required: false },
        enabled: { type: 'boolean', required: true, input: false },
        ordering: { type: 'number', required: true, input: false },
      },
    }),
  ],
})

export const { useSession, signIn, signOut, requestPasswordReset, resetPassword } = authClient
